module.exports = __webpack_public_path__ + "static/img/13.550fe88.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/zh/13.png
// module id = pFsd
// module chunks = 0